module.exports = __webpack_public_path__ + "static/shafiq-8e89e9183a711d6d0f9212ada3dd48dd.jpeg";